'use client';

import { Button } from '@extern/ui/button';
import { Icons } from '@extern/ui/icons';

import { useLastAuthenticationStrategy } from '../_hooks/use-last-authentication-strategy';
import { AuthLastUsedButtonWrap } from './auth-last-used-badge';

interface AuthGoogleButtonProps {
  isLoading: boolean;
  label: string;
  onClick: () => void;
}

export function AuthGoogleButton({ label, onClick, isLoading }: AuthGoogleButtonProps) {
  const lastAuthenticationStrategy = useLastAuthenticationStrategy();

  return (
    <AuthLastUsedButtonWrap matchStrategy="oauth_google" strategy={lastAuthenticationStrategy}>
      <Button
        appearance="filled"
        className="w-full"
        disabled={isLoading}
        isLoading={isLoading}
        onClick={onClick}
        type="button">
        <Icons.Google className="size-4" />
        {label}
      </Button>
    </AuthLastUsedButtonWrap>
  );
}
